import React, {useEffect, useState} from 'react';
import './scss/token-binding.scss';
import StatusView from "./status-view";
import Layout from "./layout";
import FullScreenLoader from "./full-screen";
import {Button} from 'react-bootstrap';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";
import SandraJsAPI from "../services/sandraJsAPI";
import TokenModel from "../models/token";
import IAsset from "../models/asset";

function TokenBinding(): React.ReactElement {

    const emptyStatus = {message: '', type: StatusMessageTypeEnum.none};
    const [statusMessage, setStatusMessage] = useState(emptyStatus);
    const [isLoading, setIsLoading] = useState(false);
    const [filterId, setFilterId] = useState("");
    const [tokenId, setTokenId] = useState("");
    const [tokenSubjectId, setTokenSubjectId] = useState("");
    const [token, setToken] = useState({tokenId: "", tokenUrl: ""} as TokenModel);
    const [bindingMap, setBindingMap] = useState(new Map<any, any[]>())


    useEffect(() => {
        fetchToken()
    }, [tokenId]);

    const fetchToken = () => {
        if (tokenId?.length > 0) {
            setIsLoading(true);
            setStatusMessage(emptyStatus)
            SandraJsAPI.getTokenBindings(tokenId).then((data: any) => {
                setIsLoading(false);
                bind(data.data)
                console.log(data)
            }).catch(e => {
                setStatusMessage({message: e.message, type: StatusMessageTypeEnum.error});
                console.error(e)
                setIsLoading(false);
            })
        }
    }

    const bind = (data: any) => {
        setTokenSubjectId(data?.subjectId)
        setToken({tokenId: data?.code, tokenUrl: ""})
        let map: Map<any, any[]> = new Map<any, any[]>();

        data?.joined?.forEach((j: any) => {
            let verb: any = j[Object.keys(j)[0]].hasOwnProperty("verb_entity") ? j[Object.keys(j)[0]]["verb_entity"] : {"subjectId": 0};
            let target: any = j[Object.keys(j)[0]];
            let vFilter: any;

            map.forEach((t, v) => {
                if (v.id.toLowerCase() === verb.id.toLowerCase()) {
                    vFilter = verb;
                }
            })

            let verbColls: any[] = [];

            verb.joined?.forEach((j: any) => {
                if (j.hasOwnProperty("inCollection")) {
                    verbColls.push(j["inCollection"])
                }
            })

            verb.collections = verbColls;

            let assetCollections: any[] = [];
            let assetContracts: any[] = [];

            target.joined?.forEach((j: any) => {
                if (j.hasOwnProperty("bindToCollection")) {
                    assetCollections.push(j["bindToCollection"])
                }
                if (j.hasOwnProperty("bindToContract")) {
                    assetContracts.push(j["bindToContract"])
                }
            })

            target.collections = assetCollections;
            target.contracts = assetContracts;

            if (vFilter) {
                map.get(verb)?.push(target as IAsset)
            } else {
                map.set(verb, [target as IAsset])
            }
        })
        console.log(map);

        setBindingMap(map);
    }


    return (
        <Layout className="page token loading-wrapper">
            <StatusView status={statusMessage}/>
            {isLoading ? <FullScreenLoader/> : <div/>}
            <div className="normal-text-italic search">
                <div className="row justify-content-center">
                    <div className="col-3">
                        <input
                            type="text"
                            className="form-control "
                            placeholder="Token Id"
                            value={filterId}
                            onChange={(e) => setFilterId(e.target.value)}
                        />
                    </div>
                    <div className="col-3">
                        <Button className="w-100" variant="primary"
                                onClick={(e) => {
                                    e.preventDefault();
                                    setTokenId(filterId)
                                    return false;
                                }}
                        >
                            Search Token
                        </Button>
                    </div>
                </div>
                <div className="row pt-4">
                    <div className="col-md-12">
                        <div><span
                            className="pe-3"><strong>Subject Id:</strong></span><span>{tokenSubjectId}</span>
                        </div>
                        <div className="mb-4"><span
                            className="pe-3"><strong>Token Id:</strong></span><span>{token.tokenId}</span>
                        </div>
                        {Array.from(bindingMap.keys()).map((contract: any) => (
                            <div key={contract.id}>
                                <div className="p-2 mb-1" style={{backgroundColor: "#f0f8ff"}}>
                                    <strong>{contract.id}</strong>
                                    <span
                                        className="float-end">  <strong>{contract["brothers"]["is_a"]}  </strong></span>
                                </div>
                                <div className="p-2 mb-4" style={{backgroundColor: "#f0f0f0"}}>
                                    <div><strong>Belongs to collections </strong></div>
                                    {contract.collections?.map((c: any) => (
                                        <div className="pt-1" >{c.Title}</div>
                                    ))}
                                </div>
                                {bindingMap.get(contract)?.map((asset, index) => (
                                    <div key={index} className="row mb-4">
                                        <div className="col-md-3 text-center">
                                            <img src={asset.imgURL} style={{maxWidth: "100px"}}/>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1">
                                                <span
                                                    className="p-3"><strong>Subject Id:</strong></span><span>{asset.subjectId}</span>
                                            </div>
                                            <div className="mb-1"><span
                                                className="p-3"><strong>Name:</strong></span><span>{asset.name}</span>
                                            </div>
                                            <div className="mb-1"><span
                                                className="p-3"><strong>Desc:</strong></span><span>{asset.description}</span>
                                            </div>
                                            <div className="mb-1"><span
                                                className="p-3"><strong>Asset Id:</strong></span><span>{asset.assetId}</span>
                                            </div>
                                            <div className="mb-1"><span
                                                className="p-3"><strong>Cannon Asset Id:</strong></span><span>{asset.cannon_assetId}</span>
                                            </div>
                                            <div className="mb-1"><span
                                                className="p-3"><strong>Metadata url:</strong></span><span>{asset.metaDataURL}</span>
                                            </div>
                                            <div className="mb-1"><span
                                                className="p-3"><strong>Image url:</strong></span><span>{asset.imgURL}</span>
                                            </div>
                                            <div className="ps-3">
                                                <div> <strong> Bound to collections </strong></div>
                                                {asset.collections?.map((col: any, index: any) => (
                                                    <div> {col.Title} </div>
                                                ))}

                                            </div>
                                            <div className="ps-3">
                                                <div>  <strong> Bound to contracts  </strong> </div>
                                                {asset.contracts?.map((con: any, index: any) => (
                                                    <div> <span>{con.id} </span > <span className="float-end"> {con["brothers"]["is_a"]} </span> </div>
                                                ))}

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </Layout>
    );

}

export default TokenBinding;
